<div *transloco="let t;read: 'workers'">
  <ng-select *ngIf="inputType === 'dropdown'" [items]="options" [bindLabel]="bindLabel" [bindValue]="bindValue"
    [placeholder]="placeholder" [disabled]="disabled" [ngModel]="value" (ngModelChange)="handleChange($event)"
    (blur)="onTouched()">
  </ng-select>

  <!-- Multi-Select Input -->
  <ng-select class="form-control" *ngIf="inputType === 'multiSelect'" [items]="options" [multiple]="true"
    [bindLabel]="bindLabel" [bindValue]="bindValue" [closeOnSelect]="false" [placeholder]="placeholder"
    (blur)="onTouched()" [maxSelectedItems]="2">
    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index"
      (ngModelChange)="handleChange($event)">
      <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" />
      {{ item[bindLabel] }}
    </ng-template>
  </ng-select>

  <!-- Input-Search -->
  <!-- <ng-select class="form-control" *ngIf="inputType === 'inputSearch'" [items]="options" [ngModel]="value"
  [addTag]="true" [placeholder]="placeholder" [hideSelected]="true" [bindLabel]="'nameEn'" [bindValue]="'nameEn'"
  (ngModelChange)="handleChange($event)" (blur)="onTouched()">
</ng-select>
{{options | json}} -->
  <ng-select class="form-control" *ngIf="inputType === 'inputSearch'" [items]="options" [ngModel]="value"
    [disabled]="disabled" [addTag]="addStateTag.bind(this)" [placeholder]="placeholder" [minTermLength]="3"
    [hideSelected]="true" [bindLabel]="'nameEn'" [bindValue]="'nameEn'" (ngModelChange)="handleChange($event)"
    (blur)="onTouched()">
  </ng-select>

  <ng-select *ngIf="inputType ==='disableOptionInputSearch'" class="form-control" [items]="options" [ngModel]="value"
    addTagText="Add" [addTag]="addStateTag.bind(this)" [placeholder]="placeholder" [minTermLength]="3"
    [hideSelected]="true" [bindLabel]="bindLabel" [bindValue]="bindValue" (ngModelChange)="handleChange($event)"
    (blur)="onTouched()" (search)="onSearch($event)" [isOpen]="dropDownMonitor" [disabled]="disabled">
  </ng-select>
  <small *ngIf="maxlengthValidations && errorMsg" class="text-danger">
    {{ t(errorMsg) }}
  </small>

  <div *transloco="let t;read: 'workers'">
    <ng-select *ngIf="inputType ==='countryInput'" [items]="options" [ngModel]="value" [searchFn]="customSearchFn"
      bindValue="code" [bindLabel]="currentLang === 'en' ? 'nameEn' : 'nameAr'"
      placeholder="{{ t('addWorkers.enterCountry') }}">
      <ng-template ng-option-tmp let-item="item">
        <span [ngClass]="['fi', 'fi-' + item.code.toLowerCase(), 'fis']" class="me-2"></span>
        {{ currentLang === 'en' ? item.nameEn : item.nameAr }}
      </ng-template>
      <ng-template ng-label-tmp let-item="item">
        <span [ngClass]="['fi', 'fi-' + item.code.toLowerCase(), 'fis']" class="me-2"></span>
        {{ currentLang === 'en' ? item.nameEn : item.nameAr }}
      </ng-template>
    </ng-select>
  </div>
</div>